import { observable, action } from "mobx";

class Store {
    @observable visible = false;

    @action
    onShow = () => {
        this.visible = true;
    }

    @action
    onCancel = () => {
        this.visible = false;
    }

}

const applybilling = new Store();

export default applybilling;


// WEBPACK FOOTER //
// ./src/components/user/Logistics/store.js